// Imports
import _axios from '@/api/axios'
import { parse } from '@/modules/json-bignum/json'
class API {
  constructor ({ url }) {
    this.url = url
    this.endpoints = {}
  }
  handleSuccess (res) {
    if (res) {
      let { status } = res
      if (status === 200 || status === 201) {
        let responseText = res.request.responseText
        if (responseText) {
          const parsed = parse(responseText)
          return parsed.data ? parsed.data : parsed
        }
        return res.data
      }
      if (status === 204) {
        return res
      }
    }
    return null
  }
  createEntity (entity) {
    this.endpoints[entity.name] = this.createBasicCRUDEndpoints(entity)
  }
  createEntities (arrayOfEntity) {
    arrayOfEntity.forEach(this.createEntity.bind(this))
  }
  createBasicCRUDEndpoints ({ name }) {
    let endpoints = {}
    const resourceURL = `${this.url}/${name}`
    endpoints.getAll = ({ query } = {}) => _axios.get(resourceURL, { params: query }).then(this.handleSuccess)
    endpoints.getOne = ({ id }) => _axios.get(`${resourceURL}/${id}`).then(this.handleSuccess)
    endpoints.create = (toCreate) => _axios.post(resourceURL, toCreate).then(this.handleSuccess)
    endpoints.update = ({ id, toUpdate }) => _axios.put(`${resourceURL}${id ? `/${id}` : ''}`, toUpdate).then(this.handleSuccess)
    endpoints.patch = ({ id, toPatch }) => _axios.patch(`${resourceURL}${id ? `/${id}` : ''}`, toPatch).then(this.handleSuccess)
    endpoints.delete = ({ id }) => _axios.delete(`${resourceURL}/${id}`).then(this.handleSuccess)
    return endpoints
  }
}

export default API
